import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/hr.png'
import _imports_1 from '../assets/img/mine/null.png'


const _withScopeId = n => (_pushScopeId("data-v-5bc99826"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" 上进青年说 "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, " 上进不是一个人的事，上进是一群人的狂欢。探索上进的力量，讲述上进故事、迸发你心中的上进者说… ", -1))
const _hoisted_3 = { class: "bx running-welfare-box" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 1,
  class: "null"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "null-img"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无动态～", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import Vue from 'vue';

import { ref, onMounted } from 'vue';
import PostDetail from '@/components/PostDetail.vue';
import { MineFetch } from '@/api/request';
import { formatEmotions, formatWrap } from '@/lib';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref<boolean>(false);
const finished = ref<boolean>(false);
const list = ref<ICircleInfoProps[]>([]);
const pagination = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 10
});

onMounted(() => {
  onLoad();
});
const onLoad = async() => {
  // 异步更新数据
  loading.value = true;

  pagination.value.pageNum += 1;
  const params = {
    userRoleType: '2',
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize
  };

  const res = await MineFetch.selRecCircleDynamics(params);
  const body = res.body;
  if (Array.isArray(body)) {
    body.forEach((item, index) => {
      // 超过100文字裁剪
      item.showText2 = false;
      if (typeof item.scText === 'string') {
        if (item.scText.length > 100) {
          item.scText2 = item.scText.substring(0, 100);
          item.showText2 = true;
        }
      }

      item.scText = formatWrap(item.scText);
      item.scText = formatEmotions(item.scText);

      item.scText2 = formatWrap(item.scText2);
      item.scText2 = formatEmotions(item.scText2);

      // 图片地址集合分割成数组
      if (item.scPicUrl) {
        item.picUrl = item.scPicUrl.split(',');
      } else {
        item.picUrl = [];
      }
      if (Array.isArray(item.praiseList)) {
        item.praiseList = item?.praiseList.slice(0, 4);
      }

      // 只有 scType === -3 extContent 才会有信息
      try {
        item.extContent = JSON.parse(item.extContent);
      } catch (e) {
        item.extContent = null;
      }
    });

    list.value = list.value.concat(body);
    // 加载状态结束
    loading.value = false;
    // 到底了
    if (body.length === 0 || body.length < pagination.value.pageSize) {
      finished.value = true;
    }
  }
  if (!body) {
    finished.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (list.value.length > 0)
          ? (_openBlock(), _createBlock(_component_van_list, {
              key: 0,
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了",
              onLoad: onLoad,
              class: "list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "list-item"
                  }, [
                    _createVNode(PostDetail, { "post-info": item }, null, 8, ["post-info"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      ])
    ])
  ]))
}
}

})